var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserBorderedGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#34ce72",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 25.8c5.965 0 10.8-4.835 10.8-10.8 0-5.964-4.835-10.8-10.8-10.8C9.035 4.2 4.2 9.036 4.2 15c0 5.965 4.835 10.8 10.8 10.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#34ce72",
    fill: "#34ce72",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 23.4c0-3.313-2.686-6-6-6s-6 2.687-6 6M15 16.2c1.988 0 3.6-1.612 3.6-3.6S16.988 9 15 9s-3.6 1.612-3.6 3.6 1.612 3.6 3.6 3.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBorderedGreen);
export default __webpack_public_path__ + "static/media/user-bordered-green.9d803c82.svg";
export { ForwardRef as ReactComponent };